import { TextField } from '@material-ui/core'
import React from 'react'

export default function TextFieldComponent(props) {
    return (
        <TextField 
        fullWidth  
        name={props.name} 
        value={props.value} 
        placeholder={props.placeholder}
        type={props.textFieldType ? props.textFieldType : "text" }
        onChange={(e)=>props.onchange(e.target.value,props.type)}
            style={{
                padding: "5px",
                border: "1px solid #E5E5E5",
                borderRadius:"5px",
                backgroundColor:"#fff"
            }}
            multiline = {props.multiline ? props.multiline : false}
            minRows={props.minRows ? props.minRows : 1}
            InputProps={{ disableUnderline: true }}
        />
    )
}
